import { render } from "./ModalSendInvoice.vue?vue&type=template&id=5792d0e9&scoped=true&ts=true"
import script from "./ModalSendInvoice.vue?vue&type=script&lang=ts"
export * from "./ModalSendInvoice.vue?vue&type=script&lang=ts"

import "./ModalSendInvoice.vue?vue&type=style&index=0&id=5792d0e9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5792d0e9"]])

export default __exports__